import { cpfTransform } from '../../shared/utils/utils'

export type CodigoExclusaoEscala = 'ocupado' | 'impedimento' | 'descanso' | 'jornada'

// Record<string, ...> (não Record<CodigoExclusaoEscala, ...>) de propósito — os
// candidatos vêm da API como `any`, e indexar um Record de union type com uma
// chave `any` é erro de template strict (NG3), mesmo em runtime funcionando igual.
export const CODIGO_EXCLUSAO_LABEL: Record<string, string> = {
  ocupado: 'Ocupado',
  impedimento: 'Impedimento',
  descanso: 'Descanso insuficiente',
  jornada: 'Excede jornada',
}

export class CandidatoEscalaVm {
  public motoristaId = 0
  public nome = ''
  // Só dígitos — formatar na tela. Serve pra separar homônimos na hora de escolher.
  public cpf: string | null = null
  public tipoMotoristaId: number | null = null
  public tipoMotorista: string | null = null // ex.: "Monolíngue"
  public elegivel = false
  public posicao = 0
  public motivoExclusao: string | null = null
  public codigoExclusao: CodigoExclusaoEscala | null = null

  public comissaoAcumulada: number | null = null
  public ultimoServicoFim: string | null = null
  public ultimoServicoDestino: string | null = null
  public chegouEmCasa: string | null = null
  public chegadaConfirmada = false
  public descansoHoras: number | null = null
  public jornadaPrevistaHoras: number | null = null
  public casaMaisProxima: string | null = null
  public distanciaKm: number | null = null

  public avisoRodizio = false
  public detalheRodizio: string | null = null
}

// "CPF 127.605.298-78 · Monolíngue" ao lado do nome do candidato — vazio quando o
// back não mandou nenhum dos dois.
export function identificacaoCandidato(candidato: CandidatoEscalaVm): string {
  return [candidato.cpf ? `CPF ${cpfTransform(candidato.cpf)}` : null, candidato.tipoMotorista]
    .filter(Boolean)
    .join(' · ')
}

export class SugestaoEscalaVm {
  public ordemServicoId = ''
  public data = ''
  public horaInicio = ''
  public origem = ''
  public destino = ''

  public totalAvaliados = 0
  public totalElegiveis = 0
  public motoristaSugeridoId: number | null = null
  public motoristaSugerido: string | null = null
  public fonteProximidade: 'google' | 'cidade' | 'indisponivel' = 'indisponivel'

  public candidatos: CandidatoEscalaVm[] = []
}

export class AlocacaoEscalaModel {
  public ordemServicoId = ''
  public motoristaId = 0
  public veiculoId?: string | null
}

export class ConfirmarEscalaModel {
  public alocacoes: AlocacaoEscalaModel[] = []
}

export class SugerirDiaModel {
  public data = ''
  public estado?: string | null
}

export class ResumoValorMotoristaSearchModel {
  public dataInicio: string | null = null
  public dataFinal: string | null = null
  public nome: string | null = null
  public apenasFrotaPropria = true
}

export class ResumoValorMotoristaVm {
  public motoristaId = 0
  public nome = ''
  public totalServicos = 0
  public valorServico = 0
  public primeiroServico = ''
  public ultimoServico = ''
}
